/* eslint-disable */
export const deleteDepthBotConstants = {
    FETCH_DELETE_DEPTH_BOT_REQUEST: 'FETCH_DELETE_DEPTH_BOT_REQUEST',
    FETCH_DELETE_DEPTH_BOT_SUCCESS: 'FETCH_DELETE_DEPTH_BOT_SUCCESS',
    FETCH_DELETE_DEPTH_BOT_FAILURE: 'FETCH_DELETE_DEPTH_BOT_FAILURE',
};
